import React from 'react';

function NotFoundBody(props) {
    function GoHome(){
        window.location.href='/'
    }
    return (
        <div className='flex flex-col items-center space-y-2 my-20'>
            <span className='text-[80px] font-[500]'>404</span>
            <div><button onClick={GoHome} className='w-40 bg-[#008B39] rounded-[4px] p-2 text-white'>Go Home</button></div>
        </div>
    );
}

export default NotFoundBody;